var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from '@marketing/components/global/Carousel';
import { useMediaQuery } from '@mui/material';
import Step from '../Step';
function StartingFreshCarousel(_a) {
    var steps = _a.steps, _b = _a.theme, theme = _b === void 0 ? 'light' : _b;
    var gap = useMediaQuery('(min-width: 768px)') ? 48 : 0;
    return (_jsx("div", __assign({ className: "w-[265px] md:w-[460px]" }, { children: _jsx(Carousel, __assign({ theme: theme, controlsPadding: "!px-0 !pt-xl-m", gap: gap, hideOverflow: false }, { children: steps.map(function (step) { return (_jsx(Step, { stepNumber: step.stepNumber, title: step.title, description: step.description }, step.stepNumber)); }) })) })));
}
export default StartingFreshCarousel;
